<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/T7vTZB/tc-custom/9780765396914.jpg?1738254612553" alt="This image is the cover for the book City of Lies, The Poison Wars"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">City of Lies, The Poison Wars
      </h1>
      <p class="bookDescription body article font2">
        <p><b>WINNER of the Ditmar Awards for Best Novel and Best New Talent, the Norma K Hemming Award, and the Aurealis Award for Best Fantasy Novel!</b><br/><br/><b>Poison. Treachery. Ancient spirits. Sieges. The Poison Wars begin now, with <i>City of Lies</i>, a fabulous epic fantasy debut by Sam Hawke</b><br/><br/><i>I was seven years old the first time my uncle poisoned me...</i><br/><br/> Outwardly, Jovan is the lifelong friend of the Chancellor’s charming, irresponsible Heir. Quiet. Forgettable. In secret, he's a master of poisons and chemicals, trained to protect the Chancellor’s family from treachery. When the Chancellor succumbs to an unknown poison and an army lays siege to the city, Jovan and his sister Kalina must protect the Heir and save their city-state.<br/><br/> But treachery lurks in every corner, and the ancient spirits of the land are rising...and angry. </p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Sam Hawke
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Tom Doherty Associates
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?c963febc